import { render, staticRenderFns } from "./unavailable-bill.vue?vue&type=template&id=5535e28a&scoped=true&"
var script = {}
import style0 from "./unavailable-bill.vue?vue&type=style&index=0&id=5535e28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535e28a",
  null
  
)

export default component.exports